import React, { useMemo, useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import DroppableCourt from './DroppableCourt';

import { CourtGridItemHeight, CourtGridItemWidth } from '../../../utils/nextAvailable';

import styles from './nextAvailable.scss';
import { sportTypeIds } from '../../../utils/eventConstants';

const NextAvailableCalendar = (props) => {
    const {
        eventId,
        sportTypeId,
        className,
        playersDictByMemberId,
        teamsDict,
        eventSchedule,
        onPostScoreClick,
    } = props;

    const calendarRef = useRef();
    const [windowWidth, setWindowWidth] = useState();

    const nextAvailable = useSelector(({ nextAvailable }) => nextAvailable);

    const courtsList = useMemo(() => {
        return nextAvailable?.courtsOfSelectedFacility || [];
    }, [nextAvailable?.courtsOfSelectedFacility]);

    const customStyles = useMemo(() => {
        let gridItemWidth = CourtGridItemWidth;
        const gridItemHeight = CourtGridItemHeight;
        let columnsCount = 4;
        let columnWidthString = '';
        let columnHeightString = '';

        if (calendarRef.current) {
            columnsCount = Math.floor(calendarRef.current.clientWidth / gridItemWidth);
            gridItemWidth = calendarRef.current.clientWidth / columnsCount;

            const remainderWidth = calendarRef.current.clientWidth % CourtGridItemWidth;
            if (remainderWidth > 0) {
                const newWidth = calendarRef.current.clientWidth / (columnsCount + 1);
                if (CourtGridItemWidth - newWidth < 30) {
                    columnsCount += 1;
                    gridItemWidth = newWidth;
                }
            }
        }

        for (let i = 0; i < columnsCount; i += 1) {
            columnWidthString += `${gridItemWidth}px `;
        }

        const rowsCount = Math.ceil(courtsList.length / columnsCount);
        for (let i = 0; i < rowsCount; i += 1) {
            columnHeightString += `${gridItemHeight}px `;
        }

        return {
            gridTemplateColumns: columnWidthString,
            gridTemplateRows: columnHeightString,
        };
    }, [calendarRef?.current?.offsetWidth, courtsList, windowWidth]);

    useEffect(() => {
        const saveWindowWidth = debounce(() => {
            setWindowWidth(window.innerWidth);
        }, 100);

        window.addEventListener('resize', saveWindowWidth);

        return () => {
            window.removeEventListener('resize', saveWindowWidth);
        };
    }, []);

    return (
        <div
            className={`${styles.courtGridCalendar} ${className}`}
            ref={calendarRef}
            style={customStyles}
        >
            {courtsList.map((court) => (
                <DroppableCourt
                    eventId={eventId}
                    sportTypeId={sportTypeId}
                    key={`court-${court.id}`}
                    court={court}
                    playersDictByMemberId={playersDictByMemberId}
                    teamsDict={teamsDict}
                    eventSchedule={eventSchedule}
                    onPostScoreClick={onPostScoreClick}
                />
            ))}
        </div>
    );
};

NextAvailableCalendar.propTypes = {
    className: PropTypes.string,
    eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    playersDictByMemberId: PropTypes.objectOf(PropTypes.any).isRequired,
    teamsDict: PropTypes.objectOf(PropTypes.any).isRequired,
    eventSchedule: PropTypes.objectOf(PropTypes.any).isRequired,
    sportTypeId: PropTypes.number,
    onPostScoreClick: PropTypes.func.isRequired,
};

NextAvailableCalendar.defaultProps = {
    className: '',
    sportTypeId: sportTypeIds.TENNIS,
};

export default NextAvailableCalendar;
